export default __webpack_public_path__ + "static/media/icon-coolgames.baf98b53.png";